import { AbsoluteFill } from "remotion";
import { COLORS, FONTS, LOGO, BADGE, GLOBS } from "./theme";
import { Background } from "./Background";

export const TwitterCard: React.FC<{
  headline: string;
  body: string;
  author: string;
  role: string;
}> = ({ headline, body, author, role }) => {
  return (
    <AbsoluteFill
      style={{
        background: COLORS.lightWarm,
        fontFamily: FONTS.sans,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding: "60px",
      }}
    >
      <Background theme="light" />

      <div
        style={{
          position: "absolute",
          right: -100,
          top: -100,
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: GLOBS.softGlow,
          filter: "blur(50px)",
        }}
      />
      <div
        style={{
          position: "absolute",
          left: -80,
          bottom: -80,
          width: 300,
          height: 300,
          borderRadius: "50%",
          background: GLOBS.goldSmall,
          filter: "blur(40px)",
        }}
      />

      <div style={{ marginBottom: 20, zIndex: 2 }}>
        <span style={BADGE}>O CORPO EXPLICA</span>
      </div>

      <div
        style={{
          fontFamily: FONTS.serif,
          fontSize: 42,
          fontWeight: 400,
          color: COLORS.textDark,
          lineHeight: 1.15,
          letterSpacing: "-0.02em",
          marginBottom: 16,
          zIndex: 2,
          textShadow: "0 1px 4px rgba(0,0,0,0.03)",
        }}
      >
        {headline}
      </div>

      <div
        style={{
          fontSize: 18,
          color: COLORS.stoneLight,
          lineHeight: 1.6,
          maxWidth: "85%",
          marginBottom: 36,
          fontWeight: 300,
          zIndex: 2,
        }}
      >
        {body}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          borderTop: `1px solid ${COLORS.border}`,
          paddingTop: 20,
          zIndex: 2,
        }}
      >
        <div style={{ ...LOGO, width: 44, height: 44, fontSize: 18 }}>E</div>
        <div>
          <div
            style={{ fontSize: 15, fontWeight: 600, color: COLORS.textDark }}
          >
            {author}
          </div>
          <div style={{ fontSize: 13, color: COLORS.stoneMuted }}>{role}</div>
        </div>
      </div>
    </AbsoluteFill>
  );
};
